import { db } from './db';
import { listPending } from './outbox';

export async function flushOutbox(authFetch) {
  let sent = 0;
  let failed = 0;
  const jobs = await listPending();

  for (const job of jobs) {
    let res;
    try {
      const options = { method: job.method };
      if (job.body != null) {
        options.headers = { 'Content-Type': 'application/json' };
        options.body = JSON.stringify(job.body);
      }
      res = await authFetch(job.url, options);
    } catch (e) {
      // Network/offline: leave pending, stop draining, retry later.
      await db.outbox.update(job.seq, { attempts: (job.attempts || 0) + 1 });
      break;
    }

    if (res.ok) {
      if (job.entity === 'report' && job.op === 'create') {
        const data = await res.json().catch(() => ({}));
        if (data && data.id != null) {
          await db.reports.put({ id: data.id, event_id: data.event_id, _local: true });
        }
      }
      await db.outbox.delete(job.seq);
      sent += 1;
    } else if (res.status >= 400 && res.status < 500) {
      const data = await res.json().catch(() => ({}));
      await db.outbox.update(job.seq, { status: 'error', error: (data && data.message) || `HTTP ${res.status}` });
      failed += 1;
    } else {
      // 5xx: transient, retry later; stop the drain.
      await db.outbox.update(job.seq, { attempts: (job.attempts || 0) + 1 });
      break;
    }
  }

  return { sent, failed };
}
